import { GET_OFFER_INFO_SUCCESS, CLEAR_OFFER_INFO } from 'actions/offerInfoActions';

export default function offerInfo(
	state = {
		items: []
	},
	action = null
) {
	switch (action.type) {
		case CLEAR_OFFER_INFO:
			return { items: [] };
		case GET_OFFER_INFO_SUCCESS:
			return {
				items: state.items.concat(action.data[action.dataKey].data)
			};
		default:
			return state;
	}
}
